import React, { useState } from 'react'
import useCinemaColorsAndIcons from '../hooks/useCinemaColorsAndIcons'
import getCinemaStyles from '../functions/getCinemaStyles'

const CinemaButton = ({cinema, activeClass, setActiveCinema, activeCinema}) => {
    const [mouseOver, setMouseOver] = useState(false)
    const cinemaColorSettings = useCinemaColorsAndIcons()
    const {cinemaColor} = getCinemaStyles(cinemaColorSettings, [cinema.pk]) 

    const style = cinemaColor ? activeCinema === cinema.pk ? !mouseOver ? {
        background: cinemaColor,
        borderColor: cinemaColor
    } : {
        background: cinemaColor,
        borderColor: cinemaColor
    } : !mouseOver ? {
        color: cinemaColor,
        borderColor: cinemaColor
    } : {
        background: cinemaColor,
        borderColor: cinemaColor
    } : {}


    return <div className={'performance-per-cinema-filter-button'} onMouseOver={() => {setMouseOver(true)}} onMouseOut={() => {setMouseOver(false)}}><button className={'button buttons-border cinema-filter' + activeClass} style={style} onClick={() => setActiveCinema(cinema.pk)}>{cinema.nameDisplay}</button></div>
}

export default CinemaButton